// PureNomadFlow — minimal storefront behaviour.
// Deliberately dependency-free: Shopify serves this as a plain asset.

(function () {
  'use strict';

  // --- mobile nav ---------------------------------------------------------
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var header = toggle.closest('.pnf-header');
    if (!header) return;
    var open = header.getAttribute('data-nav-open') === 'true';
    header.setAttribute('data-nav-open', String(!open));
    toggle.setAttribute('aria-expanded', String(!open));
  });

  // --- product gallery: thumbnail swaps the featured image ----------------
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    event.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    var featured = gallery && gallery.querySelector('[data-gallery-featured]');
    if (!featured) return;
    featured.src = thumb.dataset.galleryThumb;
    featured.srcset = thumb.dataset.gallerySrcset || '';
  });

  // --- build your set: live total and gift hint ---------------------------
  // The form works without this (it posts every ticked item to /cart/add);
  // here we only keep the total and the gift message honest as boxes change.
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  function updateSet(form) {
    var total = 0;
    var currency = form.dataset.currency;
    // Items with a set discount (data-price-full) are cheaper only while "this item" is ticked.
    var anchor = form.querySelector('[data-set-current]');
    var discounted = !anchor || anchor.checked;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (box) {
      var full = box.dataset.priceFull;
      var price = parseInt((full !== undefined && !discounted) ? full : (box.dataset.price || '0'), 10);
      if (box.checked) total += price;
      if (full !== undefined) {
        var item = box.closest('.pnf-set__item');
        var was = item && item.querySelector('[data-set-item-was]');
        var now = item && item.querySelector('[data-set-item-now]');
        if (was) was.hidden = !discounted;
        if (now) now.textContent = formatMoney(price, currency);
      }
    });
    var totalEl = form.querySelector('[data-set-total]');

    // Set price: with every item ticked, show the bundle price and send the
    // bundle product (pnf.set_bundle) instead of the separate items.
    var boxes = form.querySelectorAll('input[type="checkbox"]');
    var allTicked = boxes.length > 0 && Array.prototype.every.call(boxes, function (box) { return box.checked; });
    var bundle = form.dataset.bundlePrice !== undefined && allTicked;
    form.dataset.bundleActive = bundle ? '1' : '';
    var wasEl = form.querySelector('[data-set-was]');
    var noteEl = form.querySelector('[data-set-bundle-note]');
    if (wasEl) { wasEl.hidden = !bundle; wasEl.textContent = formatMoney(total, currency); }
    if (noteEl) noteEl.hidden = !bundle;
    form.querySelectorAll('[data-set-bundle-input]').forEach(function (input) { input.disabled = !bundle; });
    if (totalEl) totalEl.textContent = formatMoney(bundle ? parseInt(form.dataset.bundlePrice, 10) : total, currency);

    var submit = form.querySelector('button[type="submit"]');
    if (submit) submit.disabled = total === 0;

    // The current item's free gift is only sent while "this item" is ticked.
    var current = form.querySelector('[data-set-current]');
    form.querySelectorAll('[data-set-gift-input]').forEach(function (input) {
      input.disabled = !(current && current.checked);
    });
  }

  document.querySelectorAll('[data-set]').forEach(function (form) {
    form.addEventListener('change', function () { updateSet(form); });
    updateSet(form);
    form.addEventListener('submit', function () {
      if (form.dataset.bundleActive !== '1') return;
      form.querySelectorAll('input[type="checkbox"], [data-set-gift-input]').forEach(function (input) { input.disabled = true; });
      // The set carries the product's free gift too: the choice made under the gallery
      // ("Choose your free gift") goes in with the bundle, after it.
      form.querySelectorAll('[data-set-gift-added]').forEach(function (input) { input.remove(); });
      var gift = document.querySelector('[data-gift-choice]:checked');
      if (gift) {
        [['items[][id]', gift.value], ['items[][quantity]', '1']].forEach(function (pair) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          input.value = pair[1];
          input.setAttribute('data-set-gift-added', '');
          form.appendChild(input);
        });
      }
    });
  });
  // Coming back with the browser's back button restores the ticked items.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-set]').forEach(function (form) {
      form.querySelectorAll('input[type="checkbox"]').forEach(function (box) { box.disabled = false; });
      updateSet(form);
    });
  });

  // --- variant picker -----------------------------------------------------
  // Reads the variant JSON Shopify renders into the section and keeps the
  // hidden id input, price and availability in sync with the selects.
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var form = picker.closest('form');
    var idInput = form && (form.querySelector('[data-variant-id]') || form.querySelector('[name="id"]'));
    var submit = form && form.querySelector('[data-add-to-cart]');
    var priceEl = document.querySelector('[data-product-price]');
    var selects = Array.prototype.slice.call(picker.querySelectorAll('select[data-option-index]'));

    function currentVariant() {
      var chosen = selects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        return chosen.every(function (value, index) { return variant.options[index] === value; });
      });
    }

    function update() {
      var variant = currentVariant();

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.unavailableText || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.dataset.addText || 'Add to cart'
          : submit.dataset.soldOutText || 'Sold out';
      }

      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;

      // "Build your set" adds this product too — keep its variant in step.
      document.querySelectorAll('[data-set-current]').forEach(function (box) {
        box.value = variant.id;
        box.dataset.price = variant.price;
        var form = box.closest('[data-set]');
        var label = form && form.querySelector('[data-set-current-price]');
        if (label && variant.price_html) label.innerHTML = variant.price_html;
        if (form) updateSet(form);
      });

      // Keep the URL shareable without reloading the page.
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function (select) { select.addEventListener('change', update); });
    update();
  });

  // --- cart line quantity: submit on change, no separate Update button ----
  document.querySelectorAll('[data-cart-form] [data-quantity-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('[data-cart-form]');
      if (form) form.submit();
    });
  });

  // Badges inside a product card (itself a link) that open another page,
  // like "Find My": navigate to the badge's target instead of the product.
  function followBadge(e) {
    var badge = e.target.closest('[data-href]');
    if (!badge) return;
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = badge.getAttribute('data-href');
  }
  document.addEventListener('click', followBadge, true);
  document.addEventListener('keydown', followBadge, true);
})();
